module.exports = __webpack_public_path__ + "static/prodec_slide-3c784b3461bc951e393dd3da0734b439.png";